// P0: fix mixpanel_id being required to sign in
import axios from 'axios';
import history from './history';
// import mixpanel 
import mixpanel from "mixpanel-browser";
import userStore from './Stores/User';
mixpanel.init(process.env.REACT_APP_MIXPANEL_API_KEY);
const ENDPOINT = process.env.REACT_APP_BACKEND_URL;
const STRIPE_DRAWABOX_PRICE_ID = process.env.REACT_APP_STRIPE_DRAWABOX_PRICE_ID;
export const LOADING_SAMPLE_REFRESH_RATE = 1000; // (ms). If there are episodes loading, refresh slower so countdown timer can finish.

// Cache for the token and its expiration time
let tokenCache = {
  token: null,
  expirationTime: null
};

// Buffer time before token expiration (in seconds)
const TOKEN_REFRESH_BUFFER = 15 * 60; // 15 minutes

// Get token expiration time from JWT
const getTokenExpirationTime = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => 
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));
    const payload = JSON.parse(jsonPayload);
    return payload.exp * 1000; // Convert to milliseconds
  } catch (error) {
    console.error('Error parsing token:', error);
    return null;
  }
};

// Get token issue time from JWT
const getTokenIssueTime = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => 
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));
    const payload = JSON.parse(jsonPayload);
    return payload.iat * 1000; // Convert to milliseconds
  } catch (error) {
    console.error('Error parsing token:', error);
    return null;
  }
};

// Ensure fresh token before making API calls
const ensureFreshToken = async () => {
  const now = Date.now();

  // If we have a cached token that's not close to expiring, use it
  if (tokenCache.token && tokenCache.expirationTime) {
    const timeUntilExpiration = tokenCache.expirationTime - now;
    const tokenAge = now - getTokenIssueTime(tokenCache.token);
    
    // Refresh if token is close to expiring OR if token is older than 30 minutes
    if (timeUntilExpiration > TOKEN_REFRESH_BUFFER * 1000 && tokenAge < 30 * 60 * 1000) {
      return tokenCache.token;
    }
  }

  // Need to refresh token
  if (userStore.firebaseUser) {
    try {
      const newToken = await userStore.firebaseUser.getIdToken(true);
      const expirationTime = getTokenExpirationTime(newToken);
      
      // Update cache
      tokenCache = {
        token: newToken,
        expirationTime: expirationTime
      };
      
      userStore.idToken = newToken;
      return newToken;
    } catch (error) {
      console.error('Error refreshing token:', error);
      // If we hit quota, return existing token if available
      if (error.code === 'auth/quota-exceeded' && tokenCache.token) {
        return tokenCache.token;
      }
      throw error;
    }
  }
  return userStore.idToken;
};

export const getPresignedUrl = async (type="txt") => {
  console.log('API Call: getPresignedUrl', { type });
  const url = `${ENDPOINT}/api/upload`;
  let res = await axios.get(url, {
    params: { type: type },
  });
  const preSignedUrl = res.data;
  return preSignedUrl;
};

export const uploadTextToPresignedUrl = async (preSignedUrl, text, setButtonMessage) => {
  console.log('API Call: uploadTextToPresignedUrl', { preSignedUrl, textLength: text?.length });
  let res = await axios.put(preSignedUrl, text, {
    onUploadProgress: (progressEvent) => {
      const progressPercentage = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      setButtonMessage(progressPercentage + '%');
    },
    headers: {
      Accept: '*/*',
      'Content-Type': 'text/plain'
    },
  });
  return res;
};


export const getPreferredVoices = async (idToken) => {
  console.log('API Call: getPreferredVoices');
  const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/user/preferred_voices`;
  let res = await axios.get(url, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
  return res.data;
};

export const putPreferredVoice = async (idToken, preferredVoices) => {
  console.log('API Call: putPreferredVoice', { preferredVoices });
  const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/user/preferred_voices`;
  let res = await axios.put(
    url,
    { preferred_voices: preferredVoices },
    {
      headers: { 'Audiblogs-Id-Token': freshToken },
    }
  );
  return res.data;
};

export const signInV2 = async (idToken, mixpanelId, vipId=null) => {
  console.log('API Call: signInV2', { mixpanelId, vipId });
  const freshToken = await ensureFreshToken();
  let data = {};
  if (mixpanelId) {
    data = { mixpanel_id: mixpanelId };
  }
  if (vipId) {
    data.vip_id = vipId;
  }
  return axios.post(`${ENDPOINT}/api/user/signin`, data, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
};


export const getCustomToken = async (idToken) => {
  console.log('API Call: getCustomToken');
  const freshToken = await ensureFreshToken();
  const headers =  { 'Audiblogs-Id-Token': freshToken }
  return await axios.get(`${ENDPOINT}/api/user/custom_token`, { headers });
};

export const linkNewEmail = async (idToken, newEmail) => {
  console.log('API Call: linkNewEmail', { newEmail });
  const freshToken = await ensureFreshToken();
  let data = { new_email: newEmail };
  return axios.post(`${ENDPOINT}/api/user/email`, data, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
};

/**
 *
 * @param {int} daysAgo
 * @param {int} minPopularity
 * @returns most popular aritlces from DB
 */
export const getPopularArticles = async (daysAgo) => {
  console.log('API Call: getPopularArticles', { daysAgo });
  const url = `${ENDPOINT}/api/articles/popular`;

  let res = await axios.get(url, { params: { days_ago: daysAgo } });
  return res.data;
};

/**
 * V2 using session cookies
 */

export const addArticleToUserPlaylist = async (article, idToken, clippingWhere) => {
  console.log('API Call: addArticleToUserPlaylist', { 
    title: article.title,
    article_url: article.article_url,
    article_id: article.article_id,
    type: article.type,
    clippingWhere
  });
  const freshToken = await ensureFreshToken();
  const data = {
    title: article.title,
    article_url: article.article_url,
    article_id: article.article_id,
    text: article.text,
    html: '',
    type: article.type ? article.type : '',
    clipping_where: clippingWhere,
    voice_name: article.voice_name
  };
  return axios.post(`${ENDPOINT}/api/user/articles`, data, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
};

export const getUserPlaylist = async (idToken) => {
  console.log('API Call: getUserPlaylist');
  // const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/user/articles`;
  let res = await axios.get(url, {
    headers: { 'Audiblogs-Id-Token': idToken },
  });
  // console.log('API Call: getUserPlaylist', { res: res.data });
  return res.data;
};

export const updateArticleInPlaylist = async (article, idToken, attribute, value) => {
  console.log('API Call: updateArticleInPlaylist', { article_id: article.article_id, attribute, value });
  const freshToken = await ensureFreshToken();
  return axios.put(
    `${ENDPOINT}/api/user/articles`,
    {
      article_id: article.article_id,
      attribute,
      value,
    },
    {
      headers: { 'Audiblogs-Id-Token': freshToken },
    }
  );
};

export const getSearchResults = async (searchQuery) => {
  console.log('API Call: getSearchResults', { searchQuery });
  const url = `${ENDPOINT}/api/articles/search`;
  let res = await axios.get(url, { params: { query: searchQuery } });

  //  Parse data
  return res.data.results;
};

// Stripe

export const createDrawaboxCheckoutSession = async (idToken) => {
  console.log('API Call: createDrawaboxCheckoutSession');
  const freshToken = await ensureFreshToken();
  return fetch(`${ENDPOINT}/api/payments/create_checkout_session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Audiblogs-Id-Token': freshToken,
    },
    body: JSON.stringify({
      price_id: STRIPE_DRAWABOX_PRICE_ID,
    }),
  }).then(function (result) {
    return result.json();
  });
};

export const createCustomerPortalSession = async (idToken) => {
  console.log('API Call: createCustomerPortalSession');
  const freshToken = await ensureFreshToken();
  return fetch(`${ENDPOINT}/api/payments/create_customer_portal_session`, {
    method: 'POST',
    headers: { 'Audiblogs-Id-Token': freshToken },
  })
    .then(function (result) {
      return result.json();
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getUserEmailFromStripeCheckoutSessionid = async (sessionId) => {
  console.log('API Call: getUserEmailFromStripeCheckoutSessionid', { sessionId });
  return await axios.get(`${ENDPOINT}/api/payments/email_from_session`, {
    params: { checkout_session_id: sessionId },
  });
};

export const getUser = async (idToken) => {
  console.log('API Call: getUser');
  const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/user`;
  return axios.get(url, { headers: { 'Audiblogs-Id-Token': freshToken } });
};

export const deleteUser = async (idToken) => {
  console.log('API Call: deleteUser');
  const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/user`;
  return axios.delete(url, { headers: { 'Audiblogs-Id-Token': freshToken } });
};

export const checkIsUserPaying = async (idToken) => {
  console.log('API Call: checkIsUserPaying');
  const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/user/is_paying`;
  return axios.get(url, { headers: { 'Audiblogs-Id-Token': freshToken } });
};

export const getTriggers = async (idToken) => {
  console.log('API Call: getTriggers');
  const freshToken = await ensureFreshToken();
  const url = `${ENDPOINT}/api/triggers`;
  return axios.get(url, {
    headers: {
      'Audiblogs-Id-Token': freshToken,
    },
  });
};

export const dryrunArticle = async (articleUrl, selectionText, idToken) => {
  console.log('API Call: dryrunArticle', { articleUrl, hasSelectionText: !!selectionText });
  const freshToken = await ensureFreshToken();
  // Normalize URL if it doesn't have http/https prefix
  if (articleUrl && !/^https?:\/\//i.test(articleUrl)) {
    articleUrl = `https://${articleUrl}`;
  }
  
  return axios.post(
    `${ENDPOINT}/api/v2/article/add/dryrun`,
    {
      article_url: articleUrl,
      selection_text: selectionText,
    },
    {
      headers: { 'Audiblogs-Id-Token': freshToken },
    }
  );
};

export const createSubscriptionCheckoutSessionWithTrial = async (
  withTrial = true,
  idToken,
  data={},
  successUrl = null,
  voice = 'Unreal'
) => {
  console.log('API Call: createSubscriptionCheckoutSessionWithTrial', { withTrial, data, successUrl, voice });
  const freshToken = await ensureFreshToken();
  data.with_trial = withTrial;

  if (successUrl) data['success_url'] = successUrl;
  if (voice) data['voice'] = voice.toLowerCase();
  else data['voice'] = 'hd';

  return axios.post(
    `${ENDPOINT}/api/v3/payments/create_checkout_session_with_trial`,
    data,
    {
      headers: {
        'Audiblogs-Id-Token': freshToken,
      },
    }
  );
};

export const createReactivationCheckoutSession = async (idToken, data = {}, successUrl = null) => {
  console.log('API Call: createReactivationCheckoutSession', { data, successUrl });
  const freshToken = await ensureFreshToken();
  
  if (successUrl) data['success_url'] = successUrl;

  return axios.post(
    `${ENDPOINT}/api/v3/payments/create_checkout_session_reactivate`,
    data,
    {
      headers: {
        'Audiblogs-Id-Token': freshToken,
      },
    }
  );
};

export const topOffCredits = async (idToken, quantity, voiceQuality) => {
  console.log('API Call: topOffCredits', { quantity, voiceQuality });
  const freshToken = await ensureFreshToken();
  let data = {
    quantity: quantity,
    voice_quality: voiceQuality,
  };

  return axios.post(`${ENDPOINT}/api/payments/top_off`, data, {
    headers: {
      'Audiblogs-Id-Token': freshToken,
      'Access-Control-Allow-Origin': '*',
    },
  });
};

export const updateUserTldrPreference = async (userId, addTldr) => {
  console.log('API Call: updateUserTldrPreference', { userId, addTldr });
  return axios.put(`${ENDPOINT}/api/user/updateUser`, {
    userId,
    addTldr
  });
};

export const updateUserPrivacyMode = async (userId, privacyMode) => {
  console.log('API Call: updateUserPrivacyMode', { userId, privacyMode });
  return axios.put(`${ENDPOINT}/api/user/updateUser`, {
    userId,
    privacyMode
  });
};

export const updateUserCookieConsent = async (userId, cookieConsent) => {
  console.log('API Call: updateUserCookieConsent', { userId, cookieConsent });
  return axios.put(`${ENDPOINT}/api/user/updateUser`, {
    userId,
    cookieConsent
  });
};

/**
 * Get latest articles for multiple feeds in a single request
 * @param {string[]} feedIds - Array of feed IDs
 * @returns {Promise} - Promise that resolves with the latest articles data
 */
export const getLatestArticlesForFeeds = async (feedIds) => {
  console.log('API Call: getLatestArticlesForFeeds', { feedIds });
  const url = `${ENDPOINT}/api/feeds/latest_articles`;
  try {
    const response = await axios.post(url, { feed_ids: feedIds });
    return response.data;
  } catch (error) {
    console.error("Error in getLatestArticlesForFeeds:", error);
    return {};
  }
};

/**
 * Get all RSS feeds that the user is subscribed to
 * @param {string} idToken - The user's ID token
 * @returns {Promise} - Promise that resolves with the API response containing the user's feeds
 */
export const getUserFeeds = async (idToken) => {
  console.log('API Call: getUserFeeds');
  const url = `${ENDPOINT}/api/feeds`;
  try {
    const response = await axios.get(url, { 
      headers: { 'Audiblogs-Id-Token': idToken },
      params: { _t: new Date().getTime() }
    });
    
    // If we have feeds, fetch their latest articles in batch
    if (response.data?.feeds?.length > 0) {
      const feedIds = response.data.feeds.map(feed => feed.feed_id || feed.id);
      const latestArticles = await getLatestArticlesForFeeds(feedIds);
      
      // Merge latest articles data with feeds
      response.data.feeds = response.data.feeds.map(feed => {
        const latestArticle = latestArticles[feed.feed_id || feed.id];
        if (latestArticle) {
          return {
            ...feed,
            thumbnail_url: latestArticle.thumbnail_url || feed.thumbnail_url,
            audio_url: latestArticle.audio_url,
            article_id: latestArticle.article_id,
            article_title: latestArticle.title,
            article_url: latestArticle.url,
            latestArticle
          };
        }
        return feed;
      });
    }
    
    return response;
  } catch (error) {
    console.error("Error in getUserFeeds:", error.message);
    return { data: { feeds: [] } };
  }
};

/**
 * Add a new RSS feed for the user
 * @param {string} idToken - The user's ID token
 * @param {string} feedUrl - The URL of the RSS feed to add
 * @returns {Promise} - Promise that resolves with the API response
 */
export const addUserFeed = async (idToken, feedUrl) => {
  console.log('API Call: addUserFeed', { feedUrl });
  const url = `${ENDPOINT}/api/feeds`;
  return axios.post(
    url,
    { feed_url: feedUrl },
    { headers: { 'Audiblogs-Id-Token': idToken } }
  );
};

/**
 * Delete (unsubscribe from) a RSS feed
 * @param {string} idToken - The user's ID token
 * @param {string} feedId - The ID of the feed to delete
 * @returns {Promise} - Promise that resolves with the API response
 */
export const deleteUserFeed = async (idToken, feedId) => {
  console.log('API Call: deleteUserFeed', { feedId });
  const url = `${ENDPOINT}/api/feeds/unsubscribe/${feedId}`;
  console.log('Deleting feed with URL:', url);
  return axios.post(url, {}, { 
    headers: { 
      'Audiblogs-Id-Token': idToken
    }
  });
};

/**
 * Get the latest article from a specific feed
 * @param {string} feedId - The ID of the feed
 * @returns {Promise} - Promise that resolves with the latest article data
 */
export const getLatestFeedArticleFromFeed = async (feedId) => {
  console.log('API Call: getLatestFeedArticleFromFeed', { feedId });
  try {
    const { articles } = await getFeed(feedId);
    if (!articles || articles.length === 0) return null;
    
    // Sort articles by date and find first non-placeholder
    const sortedArticles = articles
      .filter(article => article.audio_url && !article.audio_url.includes('placeholder'))
      .sort((a, b) => new Date(b.date_added) - new Date(a.date_added));
    
    return sortedArticles[0] || null;
  } catch (error) {
    console.error(`Error fetching latest article for feed ${feedId}:`, error);
    return null;
  }
};

/**
 * Get popular RSS feeds
 * @param {number} limit - Maximum number of feeds to return
 * @returns {Promise} - Promise that resolves with the API response containing popular feeds
 */
export const getAllFeeds = async () => {
  console.log('API Call: getAllFeeds');
  const url = `${ENDPOINT}/api/feeds/popular`;
  try {
    const response = await axios.get(url);
    
    // If we have feeds, fetch their latest articles in batch
    if (response.data?.feeds?.length > 0) {
      const feedIds = response.data.feeds.map(feed => feed.feed_id || feed.id);
      const latestArticles = await getLatestArticlesForFeeds(feedIds);
      
      // Merge latest articles data with feeds
      response.data.feeds = response.data.feeds.map(feed => {
        const latestArticle = latestArticles[feed.feed_id || feed.id];
        if (latestArticle) {
          return {
            ...feed,
            thumbnail_url: latestArticle.thumbnail_url || feed.thumbnail_url,
            audio_url: latestArticle.audio_url,
            article_id: latestArticle.article_id,
            article_title: latestArticle.title,
            article_url: latestArticle.url,
            latestArticle
          };
        }
        return feed;
      });
    }
    
    return response;
  } catch (error) {
    console.error("Error in getAllFeeds:", error);
    return { data: { feeds: [] } };
  }
};

/**
 * Validates a coupon code with Stripe
 * @param {string} idToken - The user's ID token
 * @param {string} couponCode - The coupon code to validate
 * @returns {Promise} - Promise that resolves with the coupon validation result
 */
export const validateCoupon = async (idToken, couponCode) => {
  console.log('API Call: validateCoupon', { couponCode });
  const freshToken = await ensureFreshToken();
  try {
    const url = `${ENDPOINT}/api/payments/validate_coupon`;
    const response = await axios.post(
      url,
      { coupon: couponCode },
      { headers: { 'Audiblogs-Id-Token': freshToken } }
    );
    return response.data;
  } catch (error) {
    console.error('Error validating coupon:', error);
    return { 
      error: error.response?.data?.error || 'Failed to validate coupon' 
    };
  }
};

/**
 * Cancels a Stripe setup intent
 * @param {string} idToken - The user's ID token
 * @param {string} setupIntentId - The ID of the setup intent to cancel
 * @returns {Promise} - Promise that resolves with the cancellation result
 */
export const cancelSetupIntent = async (idToken, setupIntentId) => {
  console.log('API Call: cancelSetupIntent', { setupIntentId });
  const freshToken = await ensureFreshToken();
  try {
    const url = `${ENDPOINT}/api/payments/cancel_setup_intent`;
    const response = await axios.post(
      url,
      { setup_intent_id: setupIntentId },
      { headers: { 'Audiblogs-Id-Token': freshToken } }
    );
    return response.data;
  } catch (error) {
    console.error('Error canceling setup intent:', error);
    return { 
      error: error.response?.data?.error || 'Failed to cancel setup intent' 
    };
  }
};

export const getMonthlyConversions = async (idToken) => {
  console.log('API Call: getMonthlyConversions');
  const freshToken = await ensureFreshToken();
  return axios.get(`${ENDPOINT}/api/user/monthly-conversions`, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
};

export const getUserCharacters = async (idToken) => {
  console.log('API Call: getUserCharacters');
  const freshToken = await ensureFreshToken();
  return axios.get(`${ENDPOINT}/api/user/characters`, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
};

/**
 * Award bonus characters for completing gamification actions
 * @param {string} idToken - The user's ID token
 * @param {string} action - The action that was completed
 * @param {number} bonusAmount - The amount of characters to award
 * @returns {Promise} - Promise that resolves with the API response
 */
export const awardBonusCharacters = async (idToken, action, bonusAmount) => {
  console.log('API Call: awardBonusCharacters', { action, bonusAmount });
  const freshToken = await ensureFreshToken();
  return axios.post(`${ENDPOINT}/api/user/bonus-characters`, 
    { action, bonus_amount: bonusAmount },
    { headers: { 'Audiblogs-Id-Token': freshToken } }
  );
};

/**
 * Get user's gamification progress
 * @param {string} idToken - The user's ID token
 * @returns {Promise} - Promise that resolves with the gamification data
 */
export const getGamificationProgress = async (idToken) => {
  console.log('API Call: getGamificationProgress');
  const freshToken = await ensureFreshToken();
  return axios.get(`${ENDPOINT}/api/user/gamification-progress`, {
    headers: { 'Audiblogs-Id-Token': freshToken },
  });
};

/**
 * Track partner route visit and get configuration
 * @param {string} partnerRoute - The partner route (e.g., 'techgenius')
 * @returns {Promise} - Promise that resolves with the partner configuration
 */
export const trackPartnerRoute = async (partnerRoute) => {
  console.log('API Call: trackPartnerRoute', { partnerRoute });
  try {
    const response = await axios.post(`${ENDPOINT}/api/partners/track_visit`, {
      partner_route: partnerRoute
    });
    return response.data;
  } catch (error) {
    console.error('Error tracking partner route:', error);
    return { error: 'Failed to track partner route' };
  }
};

/**
 * Track coupon route visit and get configuration
 * @param {string} couponCode - The coupon code (e.g., 'WELCOME50')
 * @returns {Promise} - Promise that resolves with the coupon configuration
 */
export const trackCouponRoute = async (couponCode) => {
  console.log('API Call: trackCouponRoute', { couponCode });
  try {
    const response = await axios.post(`${ENDPOINT}/api/coupons/track_visit`, {
      coupon_code: couponCode
    });
    return response.data;
  } catch (error) {
    console.error('Error tracking coupon route:', error);
    return { error: 'Failed to track coupon route' };
  }
};

/**
 * Track referral route visit and get configuration
 * @param {string} referralUuid - The referral UUID
 * @returns {Promise} - Promise that resolves with the referral configuration
 */
export const trackReferralRoute = async (referralUuid) => {
  console.log('API Call: trackReferralRoute', { referralUuid });
  try {
    const response = await axios.post(`${ENDPOINT}/api/referrals/track_visit`, {
      referral_uuid: referralUuid
    });
    return response.data;
  } catch (error) {
    console.error('Error tracking referral route:', error);
    return { error: 'Failed to track referral route' };
  }
};

/**
 * Complete referral signup and award bonus credits to referrer
 * @param {string} idToken - The user's ID token
 * @param {string} referralUuid - The referral UUID used during signup
 * @returns {Promise} - Promise that resolves with the completion result
 */
export const completeReferralSignup = async (idToken, referralUuid) => {
  console.log('API Call: completeReferralSignup', { referralUuid });
  const freshToken = await ensureFreshToken();
  try {
    const response = await axios.post(`${ENDPOINT}/api/referrals/complete_signup`, {
      referral_uuid: referralUuid
    }, {
      headers: { 'Audiblogs-Id-Token': freshToken }
    });
    return response.data;
  } catch (error) {
    console.error('Error completing referral signup:', error);
    return { error: 'Failed to complete referral signup' };
  }
};

/**
 * Get a specific feed and its articles by URL
 * @param {string} feedUrl - The URL of the feed to fetch
 * @returns {Promise} - Promise that resolves with the feed data and articles
 */
export const getFeed = async (feedUrl) => {
  console.log('API Call: getFeed', { feedUrl });
  const url = `${ENDPOINT}/api/get_feed/${encodeURIComponent(feedUrl)}`;
  
  try {
    const { data } = await axios.get(url);
    
    const feedData = {
      ...data.feed,
      feed_id: data.feed.id,
      title: data.feed.title || "Untitled Feed",
    };
    
    const articlesWithText = (data.articles || []).map(article => {
      const text = article.text || article.content || article.article_text;
      // console.log("Article text for:", article.title, text ? "has text" : "no text");
      return {
        ...article,
        text,
        uniqueId: article.article_id || article.id || `${article.title}-${article.date_added}`
      };
    });
    
    return { feed: feedData, articles: articlesWithText };
  } catch (error) {
    console.error("Error in getFeed:", error);
    throw error;
  }
};
